import 'bootstrap/dist/css/bootstrap.min.css';
import Bloggenerate from './Components/Bloggenerate.jsx';
import Head from './Components/Header';
import Search from './Components/Search.jsx';
function App() {
  return (
    <>
    <Head/>
    <br/>
    <Search/>
    <Bloggenerate/>
    </>
  )
}
export default App;
